import React from 'react'
import { Letter } from '../components/Letter'
import { HStack } from '@chakra-ui/react'
import type { Glossary } from '@/types/glossary'
import { StickyContainer } from '../components/StickyContainer'

type ContainerProps = {
  availableLetters: string[]
  selectedLetter: string
  setSelectedLetter: (val: string) => void
}

export const LetterContainer = ({
  availableLetters,
  selectedLetter,
  setSelectedLetter,
}: ContainerProps) => (
  <StickyContainer>
    <HStack spacing={'5px'} flexWrap={'wrap'}>
      {availableLetters.map((letter) => {
        return (
          <Letter
            key={letter}
            letter={letter}
            selectedLetter={selectedLetter}
            setSelectedLetter={setSelectedLetter}
          />
        )
      })}
    </HStack>
  </StickyContainer>
)
